import {registerMiddleware} from '@homeaway/redux-middleware-adapter';
import {registerTripBoardsMiddleware} from '@homeaway/react-trip-board-button';
import tripDataDidChange from './trip/trip';
import redirectInterceptor from './redirectInterceptor/redirectInterceptor';
import {parseSearchParams} from './searchParams/searchParams';
import modals from './modals/modals';
import {
    userAgentDidChange,
    syncMapMarkersToLocalStorage,
    mapLoaded,
    resetToInitialBounds
} from './map/map';
import routerActions from '../actions/router';
import {MAP_ADD_MARKER_CLICKED, MAP_LOADED} from '../actions/map';
import {SEARCHPARAMS_SET} from '../actions/searchParams';
import {REDIRECT_PERFORM} from '../actions/redirect';
import {VIEWPORT_USER_AGENT_CHANGED} from '../actions/viewport';
import setLocationData from './location/setLocationData';
import applyFilterEdapEvents from './filter/applyFilterEdapEvents';
import {
    SEARCH_QUERY_START,
    SEARCH_QUERY_COMPLETE
} from '../actions/searchQuery';
import {scrollToTop} from '../utils/scrollTo';
import {triggerSearchEdap} from '../utils/searchEdapUtils';
import {updateAdlFromSearchParams} from '../utils/updateAdl';
/* istanbul ignore next */
function registerAllMiddleware() {
    registerTripBoardsMiddleware(registerMiddleware);
    // List out all middleware functions and the action that they respond to
    registerMiddleware(routerActions.LOCATION_CHANGED, resetToInitialBounds);
    registerMiddleware(routerActions.LOCATION_CHANGED, modals);
    registerMiddleware(routerActions.LOCATION_CHANGED, parseSearchParams);
    registerMiddleware(routerActions.LOCATION_CHANGED, applyFilterEdapEvents);
    registerMiddleware(REDIRECT_PERFORM, redirectInterceptor);
    registerMiddleware(SEARCHPARAMS_SET, tripDataDidChange);
    registerMiddleware(VIEWPORT_USER_AGENT_CHANGED, userAgentDidChange);
    registerMiddleware(MAP_ADD_MARKER_CLICKED, syncMapMarkersToLocalStorage);
    registerMiddleware(MAP_LOADED, mapLoaded);
    registerMiddleware(SEARCH_QUERY_START, updateAdlFromSearchParams);
    registerMiddleware(SEARCH_QUERY_START, scrollToTop);
    registerMiddleware(SEARCH_QUERY_START, triggerSearchEdap);
    registerMiddleware(SEARCH_QUERY_COMPLETE, setLocationData);
    registerTripBoardsMiddleware(registerMiddleware);
}

export default registerAllMiddleware;
